import { z } from "zod";

import { zSignatureInitialsRequired } from "@/utils/zod";

const numericOrEmptyField = z.union([z.string(), z.number()]).optional();

export const laborVitalsFlowsheetFormSchema = z.object({
  vitalDate: z.date().nullable(),
  vitalTime: z.string().nullable(),
  systolic: numericOrEmptyField,
  diastolic: numericOrEmptyField,
  pulse: numericOrEmptyField,
  temperatureValue: numericOrEmptyField,
  temperatureUnit: z.string().nullable().optional(),
  temperatureMethod: z.string().nullable().optional(),
  notes: z.string().optional(),
  signatureInitials: zSignatureInitialsRequired(),
});

export type LaborVitalsFlowsheetFormSchemaType = z.infer<typeof laborVitalsFlowsheetFormSchema>;
